import type { ModernizedGenericAnnotation } from '../../../modernization-common/side-panel/types';
export function shouldShowMLAnnotations(numFrames: number, mlAnnotations: ModernizedGenericAnnotation[]) {
  const isImageLabeling = numFrames === 1;
  const hasMLAnnotations = mlAnnotations.length > 0;
  return isImageLabeling && hasMLAnnotations;
}